<au-loading-spinner></au-loading-spinner>
<div class="sp-custom-background"></div>
<div class="background-image">
</div>

<div class="page-container">
  <div class="page-layout">
    <div class="row d-flex justify-content-center header-container">
      <div id="header" class="logo-container">
        <div><img src="./assets/images/cool_logo.svg" [alt]="translate('logo-alt')" /></div>
        <div class="sub-image">
          <img src="./assets/images/cloudwise_logo.svg" [alt]="translate('cloudwise-ict-img-alt')" />
        </div>
      </div>
      <div class="notification-bar-container">
        <au-notification-bar #notificationBar id="general-error-notification-bar"></au-notification-bar>
      </div>
    </div>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>
